<template lang="pug">
    .about-ourhistory
        .about-ourhistory-title
            p
                span {{ lenguageSelected.title }}
        .about-ourhistory-description
            p(v-html="lenguageSelected.content1")
            p(v-html="lenguageSelected.content2")
            p(v-html="lenguageSelected.content3")
            p(v-html="lenguageSelected.content4")
            p(v-html="lenguageSelected.content5")
            p(v-html="lenguageSelected.content6")
</template>


<script>
export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    data: function(){
        return {
            lenguage: 'EN',
            lenguageEN: {
                title: 'Our History and Key Milestones',
                content1: '<span>September 2011 </span>- Torres Unidas launched its initial operations in the Andean region.',
                content2: '<span>February 2017 </span>- Interconexión Eléctrica S.A. (ISA) consummated an agreement to invest up to USD$80 million in ATP for the development of telecommunications infrastructure in Colombia and Peru.',
                content3: '<span>March 2017 </span>- Digital Bridge successfully completed an institutional capital raise to support growth for ATP.',
                content4: '<span> <i>Marzo 2017 </i> </span class="none_">- Along with the ISA investment agreement, ATP successfully raised $230M USD of new capital.',
                content5: '<span>December 2017 </span>- ATP acquired Torres Unidas, creating one of the largest and fastest growing infrastructure operators in the region.',
                content6: '<span>September 2018 </span>- ATP launched its optical fiber business unit, offering leased services to support data service providers in expanding and densifying their networks.',
                content7: '<span>April 2019 </span>- ATP & Torres Unidas rebranded as Andean Telecom Partners.'
            },
            
            lenguageES: {
                 title: 'Nuestra Historia y Logros',
                content1: '<span>Septiembre 2011 </span>- Torres Unidas inició sus operaciones en la región andina.',
                content2: '<span>Febrero 2017 </span>- Interconexión Eléctrica S.A. (ISA) consumó un acuerdo para invertir hasta USD $80 millones en ATP para el desarrollo de infraestructura de telecomunicaciones en Colombia y Perú.',
                content3: '<span>Marzo 2017 </span>- Digital Bridge completó un incremento de capital para respaldar el crecimiento de ATP.',
                content4: '<span> <i>Marzo 2017 </i> </span class="none_">- Junto con el acuerdo de inversión de ISA, ATP recaudó con éxito $230 millones de dólares de nuevo capital.',
                content5: '<span>Diciembre 2017 </span>- ATP adquirió Torres Unidas, formando uno de los operadores de infraestructura más grandes y de mayor crecimiento en la región.',
                content6: '<span>Septiembre 2018 </span>- ATP lanzó su unidad de negocios de fibra óptica, que ofrece servicios de arriendo y co-ubicación para apoyar a los proveedores de data en la expansión y densificación de sus redes.',
                content7: '<span>Abril 2019 </span>- ATP y Torres Unidas lanzaron su nueva marca como empresa combinada, Andean Telecom Partners.'
            },
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    },
}
</script>

<style lang="scss" >
.about-ourhistory-description i{
    opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/PmOurHistory.vue